import React,{ useContext,} from "react"
import Typewriter from 'typewriter-effect';
import Layout from "../components/layout"
import Particle from '../components/Particle'
import GetImage from '../components/Image'
import Form from '../components/Form'
import { LazyLoadImage } from 'react-lazy-load-image-component';

const ClientImg = [
  { img: '../../clients/vedantu.jpg'},
  { img: '../../clients/meesho.jpg'},
  { img: '../../clients/amarujala.jpg'},
  { img: '../../clients/transable.jpg'},
  { img: '../../clients/intellolabs.jpg'},
]
const Home = () => {

  return (
    <Layout>
      {/* <!-- **************Scroll Top Button**************--> */}
      <div className="scroll-top-btn" data-scroll-goto="0">
        <a href="#" className="scroll-top">
          <span className="scroll-top-icon"></span>
        </a>
      </div>

      <div className="page-wrapper">

        <div id="particle-container" className="particle-container fullscreen bg3" data-scroll-index="0">
          <Particle />
          <div className="grediant-overlay opacity-85"></div>
          <div className="center-col text-center white-text" id="home">
            <div className="container-fluid">
              <div className="row">
                <div
                  className="col-md-10 col-lg-8 mx-auto"
                  data-aos="fade-up"
                  data-aos-duration="600"
                  data-aos-delay="500"
                >
                  <div className="home-content">
                    <h1 className="large-heading">
                      <span className="font-weight-extralight">
                          New Age => New Solutions For
                      </span>

                      <Typewriter
                        options={{
                          loop: true,
                        }}
                        onInit={(typewriter) => {
                          typewriter.typeString('Media Investments').pauseFor(1000).deleteAll()
                            .typeString('Television').pauseFor(1000).deleteAll()
                            .typeString('Campaigns').pauseFor(1000).deleteAll()
                            .typeString('Creative').pauseFor(1000).start();
                        }}
                      />
                    </h1>
                  </div>
                  <div className="section-header pt-50">
                    <h4>
                      Make your marketing smarter with our <br /> no-code AI-led analytics software.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <!-- **************Our Steps**************--> */}
        <section className="pt-50 bg-light our-steps" data-scroll-index="1">
          <div className="container">
            <div className="row">
              <div
                className="col-md-4 mb-30"
                data-aos="fade-right"
                data-aos-duration="400"
              >
                <div className="our-step">
                  <div className="step-number text-grediant lh-n">What</div>
                  <p>
                    Don't wait for week or months to know comprehensive impact of your campaigns.
                  </p>
                </div>
              </div>
              <div
                className="col-md-4 mb-30"
                data-aos="fade-up"
                data-aos-duration="500"
              >
                <div className="our-step">
                  <div className="step-number text-grediant lh-n">Why</div>
                  <p>
                    If you lose time in measuring your campaigns, then your future campaigns can't be optimized
                  </p>
                </div>
              </div>
              <div
                className="col-md-4 mb-30"
                data-aos="fade-left"
                data-aos-duration="600"
              >
                <div className="our-step">
                  <div className="step-number text-grediant lh-n">How</div>
                  <p>
                    Using our no-code, self learn, AI-led tools, you can quickly plan, set-up and measure your campaigns
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- **************Products**************--> */}
        <section
          id="products"
          className="pt-50 pb-50 product-info"
          data-scroll-index="1"
          data-aos="fade"
          data-aos-duration="400"
        >
          <div className="container">
            <div className="section-header">
              <h2>Our Products</h2>
            </div>

            <div className="row">
              <div className="col-md-4 pl-3 pr-3 product-section">
                <a href="/product/tv-measure">
                  <div className="work-grid-box-1">
                    <div className="grid-image grid-height-250">
                      <GetImage filename="tv-meau.png" alt="measurement" />
                    </div>
                    <div className="image-box__overlay"></div>
                    <div className="imgae-over-text">
                      <h5 className="grid-title white-text">
                        Campaign Smarter
                      </h5>
                      <p className="grid-description opacity-full">
                        Plan and measure your campaigns
                      </p>
                    </div>
                  </div>
                </a>
                <div className="product-content">
                  <ul>
                    <li>Make your campaigns data driven</li>
                    <li>Plan in advance and measure in real time</li>
                    <li>Optimize campaigns in real time </li>
                    {/* <li>Target personas of TV audience</li> */}
                  </ul>
                </div>
              </div>
              <div className="col-md-4 pl-3 pr-3 product-section">
                <a href="/product/media-market">
                  <div className="work-grid-box-1">
                    <div className="grid-image grid-height-250">
                      <GetImage filename="media.png" alt="media" />
                    </div>
                    <div className="image-box__overlay"></div>
                    <div className="imgae-over-text">
                      <h5 className="grid-title white-text">
                        Media Simulator
                      </h5>
                      <p className="grid-description opacity-full">
                        Simulate and create
                      </p>
                    </div>
                  </div>
                </a>
                <div className="product-content">
                  <ul>
                    <li>Predict KPI for different marketing strategies</li>
                    <li>
                      Run virtual experiments to understand different
                      scenarios
                    </li>
                    <li>
                      Attribute KPI across the existing set of media/marketing
                      channels
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-4 pl-3 pr-3 product-section">
                <a href="/product/tv-plan">
                  <div className="work-grid-box-1">
                    <div className="grid-image grid-height-250">
                      <GetImage filename="tv-opti.png" alt="tv-opti" />
                    </div>
                    <div className="image-box__overlay"></div>
                    <div className="imgae-over-text">
                      <h5 className="grid-title white-text">TV Optimizer </h5>
                      <p className="grid-description opacity-full">
                        Amplify TV planning
                      </p>
                    </div>
                  </div>
                </a>
                <div className="product-content">
                  <ul>
                    <li>Enhance your TV planning with AI / ML power</li>
                    <li>Create multiple plans in minutes </li>
                    <li>
                      Get recommended scenarios from intelligent dashboard
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- **************Services**************--> */}
        <section
          id="products"
          className="pt-50 pb-60 bg-light product-info"
          data-scroll-index="1"
          data-aos="fade"
          data-aos-duration="400"
        >
          <div className="container">
            <div className="section-header">
              <h2>Our Services</h2>
            </div>

            <div className="row">
              <div className="col-md-4 pl-3 pr-3 product-section">
                <div className="work-grid-box-1">
                  <a href="/product/media-market">
                    <div className="grid-image grid-height-250">
                      <GetImage filename="ser-1.png" alt="service-1" />
                    </div>
                    <div className="image-box__overlay"></div>
                    <div className="imgae-over-text">
                      <h5 className="grid-title white-text">
                        Media Analytics
                      </h5>
                      <p className="opacity-full">
                        Predict and decide what marketing initiatives will
                        yield the best results
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-md-4 pl-3 pr-3 product-section">
                <div className="work-grid-box-1">
                  <a href="/product/campaign-analysis">
                    <div className="grid-image grid-height-250">
                      <GetImage filename="ser-2.png" alt="service-2" />
                    </div>
                    <div className="image-box__overlay"></div>
                    <div className="imgae-over-text">
                      <h5 className="grid-title white-text">
                        Campaign Analytics
                      </h5>
                      <p className="opacity-full">
                        Know customers more deeply
                      </p>
                    </div>
                  </a>
                </div>
              </div>
              <div className="col-md-4 pl-3 pr-3 product-section">
                <div className="work-grid-box-1">
                  <a href="/product/campaign-analysis">
                    <div className="grid-image grid-height-250">
                      <GetImage filename="ser-3.png" alt="service-3" />
                    </div>
                    <div className="image-box__overlay"></div>
                    <div className="imgae-over-text">
                      <h5 className="grid-title white-text">
                        Customer Analytics
                      </h5>
                      <p className="opacity-full">
                        Use data driven insights to optimize the campaign and
                        budget
                      </p>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <!-- **************Our Service**************--> */}
        <section
          className="services-section pt-50 pb-50"
          data-scroll-index="2">
          <div className="container">
            <div className="section-header">
              <h2>Meegrow Advantage</h2>
            </div>
            <div className="row">
              <div
                className="col-md-6 col-lg-4 "
                data-aos="fade-up"
                data-aos-duration="400"
              >
                <div className="service-card border-img">
                  <div className="icon-img">
                    <i className="fa fa-users fa-2x"></i>
                  </div>
                  <div className="service-body">
                    <h6 className="service-title">People</h6>
                    <p className="service-description">
                      Our people (or as we like to call them – Media
                      Scientists) bring together the media expertise and data
                      analytics to form a potent combination
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4 "
                data-aos="fade-up"
                data-aos-duration="600"
              >
                <div className="service-card border-img">
                  <div className="icon-img">
                    <i className="fa fa-spinner fa-2x"></i>
                  </div>
                  <div className="service-body">
                    <h6 className="service-title">Process</h6>
                    <p className="service-description">
                      We harness the technology that empowers our client to
                      reach the highest productivity through data-enabled
                      methodologies
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="col-md-6 col-lg-4 "
                data-aos="fade-up"
                data-aos-duration="800"
              >
                <div className="service-card border-img">
                  <div className="icon-img">
                    <i className="fa fa-cog fa-2x"></i>
                  </div>
                  <div className="service-body">
                    <h6 className="service-title">Technology</h6>
                    <p className="service-description">
                      Our state-of-the-art algorithms and interactive
                      dashboards let you visualise the data in an optimally
                      informative way
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- **************Clients**************--> */}
        </section>
        <div
          className="sponsors section-spacer bg-light client-section"
          data-scroll-index="6"
        >
          <div className="container">
            <div className="pb-3">
              <h2>Clients we are working with</h2>
            </div>
            <div className="row" style={{  textAlign: "center", width: "100%", }}>
              {ClientImg.map((x,i)=>(
                 <div key={"clientimg"+i} class="client-img-div">
                    <LazyLoadImage src={x.img} className="client-img"  alt="client-img" />
                   </div>
               ))}
            </div>
          </div>
        </div>

        
        {/* <!-- **************Contact Us Form**************--> */}
        <section
          className="contact-us-form theme-1 section-spacer pt-50"
          data-scroll-index="0"
        >
          <div className="container">
            <div className="section-header">
              <h2>Get in touch</h2>
            </div>
            <Form />
          </div>
        </section>

        {/* <!-- **************Contact Us**************--> */}
        <section className="contact-us bg-light" data-scroll-index="6">
          <div className="container-fluid">
            <div className="row align-items-stretch">
              <div
                className="col-md-6 p-0"
                data-aos="fade"
                data-aos-duration="400"
              >
                <div className="address-container bg2 h-100">
                  <div className="grediant-overlay-reverse opacity-85"></div>
                  <div className="address-content">
                    <div className="address-info">
                      <h2>
                        Unit No 214, Good Earth City Center Mall, Sector 50,
                        <br />
                        Gurgaon, 122018, Haryana
                      </h2>
                    </div>

                    <div className="address-info">
                      <a
                        title="Mail to support@meegrow.com"
                        className="contact-link "
                        href="mailto:support@meegrow.com"
                      >
                        support@meegrow.com
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6 p-0">
                <div className="section">
                  <a href="https://www.google.com" target="_blank" rel="noopener noreferrer"  >
                    <GetImage filename="map.png" alt="map" />
                    <div className="middle">
                      <button
                        type="submit"
                        className="btn btn-primary btn-rounded"
                      >
                        Get Direction Here
                      </button>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </Layout>
  )
}

export default Home
